module.exports = Jsw.skinUrl + "/images/tree-close.gif?56398e76be6355ad5999b262208a17c9";